class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videos = [];
    this.playButtons = [];
  }

  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('.ig-videos__video'));
    this.playButtons = Array.from(this.querySelectorAll('.ig-videos__play-btn'));
    this.unmuteButtons = Array.from(this.querySelectorAll('.ig-videos__unmute-btn'));
    this.videoWrappers = Array.from(this.querySelectorAll('.photo-collage__video-inner'));

    this.playButtons.forEach((btn, index) => {
      const video = this.videos[index];

      btn.addEventListener('click', () => {
        this.pauseAllVideos();
        video.play();
        this.videoWrappers.forEach(wrapper => {
          wrapper.classList.remove('photo-collage__video-inner--active');
        })
        video.closest('.photo-collage__video-inner').classList.add('photo-collage__video-inner--active');
        btn.style.display = 'none';
      });

      video.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          this.videoWrappers.forEach(wrapper => {
            wrapper.classList.remove('photo-collage__video-inner--active');
          })
          this.showPlayButtonFor(video);
        }
      });
    });

    this.unmuteButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        const video = this.videos[index];
        video.muted = !video.muted;
        btn.style.display = 'none';
      });
    });

    this.videos.forEach(video => {
      video.volume = 0.1;
    });
  }

  pauseAllVideos() {
    this.videos.forEach((v, i) => {
      if (!v.paused) {
        v.pause();
        this.playButtons[i].style.display = '';
      }
    });
  }

  showPlayButtonFor(video) {
    const index = this.videos.indexOf(video);
    if (index !== -1) {
      this.playButtons[index].style.display = '';
    }
  }
}

customElements.define('video-player', VideoPlayer);
